

<div class="row">
	<button style="margin-left:15px;" class="btn btn-info btn-purchasenewpack" (click)="openEngineCreate(null)">Create New Engine</button>
	<input type='text'
           style='color:black;padding: 0px 0px 0px 10px; margin:0px 0px 0px 10px;'
		   placeholder='Search Engines'
		   (keyup)='filterEngines(null, "search")' [(ngModel)]="searchText"/>
		   <span style="padding-left: 10px; vertical-align: middle; text-align: center; margin-right: 5px; margin-top: 5px">Show Inactive Engines</span>
		   <label class="switch" style="padding-left: 10px; vertical-align: middle; text-align: center;">	
		   <input		
			   id="shouldNotifyUserCreated" 
			   type="checkbox" class="form-control"
			   [(ngModel)]="displayInactive" 
			   (change)="filterEngines(null, null);">
		   <span class="slider round"></span>
		   </label>
	<button style="margin-left:15px; position: absolute; right: 30px" class="btn btn-success btn-purchasenewpack" (click)="checkEngineServices()">Check Services</button>	   
</div>
<br>

<ngx-loading [show]="loading"></ngx-loading>

<ngx-datatable
			   class='material striped datatable'
			   [rows]='display'
			   [columnMode]='"force"'
			   [headerHeight]='40'
			   [footerHeight]='20'
			   [scrollbarV]="true"
			   [rowHeight]="40"
			   [reorderable]="true"
			   [sorts]="[{prop: 'applicationName', dir: 'asc'}]"
			   [messages]="{emptyMessage:'Nothing to see here'}">						


	<ngx-datatable-column prop="status" [sortable]="true" [width]="60" [minWidth]="60" [maxWidth]="60">
		<ng-template let-column="column"  ngx-datatable-header-template let-sort="sortFn">
				<span (click)="sort()">Status</span>
		</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template >
				<div class="center">
						<div 
							placement="right" 
							container="body" 
							tooltip="Something went wrong during the build process. Click for more info" 
							*ngIf="row.status === 3" 
							style="background-color:orangered;" 
							class="circle"
							(click)="openStatusModal(row.engineWorkflowRuns)">
						</div>
						<div placement="right" container="body" tooltip="Build in progress" *ngIf="row.status === 1" style="background-color:yellow;" class="circle"></div>
						<div placement="right" container="body" tooltip="Build successful." *ngIf="row.status === 2" style="background-color:green;" class="circle"></div>
				</div>
			</ng-template>
	</ngx-datatable-column>

	<ngx-datatable-column prop="applicationName" [sortable]="true" [minWidth]="200" [maxWidth]="200">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Application Name
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.applicationName}}
		</ng-template>
	</ngx-datatable-column>  		   
		
	<ngx-datatable-column prop="config" [sortable]="true" [width]="700" [minWidth]="200" [maxWidth]="800" >
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Config Location (Bucket Name / Object Path)
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.config}}
		</ng-template>
	</ngx-datatable-column>

	<ngx-datatable-column name="dateCreated" [sortable]="true" [minWidth]="200" [maxWidth]="400">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Date Created
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.dateCreated | date:'EEEE, MMMM d, y'}}
		</ng-template>
	  </ngx-datatable-column>

	  <ngx-datatable-column name="apiKey" [width]="200" [minWidth]="200" [maxWidth]="600" >
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
				<span (click)="sort()" >
					API Key
				</span>
			</ng-template>
			<ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template >
				<a *ngIf="!copied[rowIndex + '-apiKey']" (click)="copy(row.apiKey, rowIndex)"  href='#' style="padding-right: 8px"> <i class="m-menu__link-icon flaticon-clipboard"></i></a>
				<a *ngIf="copied[rowIndex + '-apiKey']" (click)="copy(row.apiKey, rowIndex)"  href='#' style="padding-right: 8px"> <i class="m-menu__link-icon flaticon-close"></i></a>
	
				<a *ngIf="!showing[rowIndex + '-apiKey']" href='#'(click)="showing[rowIndex + '-apiKey'] = true" >Show</a>
				<a *ngIf="showing[rowIndex + '-apiKey']" href='#'  (click)="showing[rowIndex + '-apiKey'] = false">{{row.apiKey}}</a>  
			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column prop="edit" [minWidth]="120" [maxWidth]="200">
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
				<span>
					Actions
				</span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template >
				<button type="button" (click)="editEngine(row)">Edit</button>
				<button type="button" (click)="viewEngineStats(row)">Reports</button>
			</ng-template>
		</ngx-datatable-column>	

		<ngx-datatable-column prop="active" [sortable]="true" [minWidth]="60">
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			  <span (click)="sort()">
				Active
			  </span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template>
				<input (click)="toggleActive(row.engineId)" [checked]="row.active" type="checkbox" data-toggle="toggle">
			</ng-template>
		  </ngx-datatable-column>
</ngx-datatable>


				

							
				 
